import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { APP_NAME } from "@sdk/lib/functions/format-page-title";

@Injectable({ providedIn: "root" })
export class TranslocoTitleStrategy extends TitleStrategy {
  private readonly _title = inject(Title);
  private readonly _transloco = inject(TranslocoService);
  private _currentKey: string | null = null;

  constructor() {
    super();
    this._transloco.langChanges$.subscribe(() => this._apply());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this._currentKey = this.buildTitle(snapshot) ?? null;
    this._apply();
  }

  private _apply(): void {
    const brand = this._transloco.translate("common.brandName") || APP_NAME;
    const translated = this._currentKey
      ? this._transloco.translate(this._currentKey)
      : "";
    this._title.setTitle(translated ? `${translated} | ${brand}` : brand);
  }
}
